package de.geomobile.frontend.utils

fun String.isValidJson() = try {
    JSON.parse<Any>(this).let { true }
} catch (e: Throwable) {
    false
}